import { render, staticRenderFns } from "./NbSelectTableButtonFields.vue?vue&type=template&id=534c71e6&"
import script from "./NbSelectTableButtonFields.vue?vue&type=script&lang=js&"
export * from "./NbSelectTableButtonFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports